import {SearchQueryParams} from '../../models/search-query-params.model';
import {ValidationError} from '../../models/validation-error.model';

export namespace RepositoryPoliciesActions {
    export class GetListPage {
        static readonly type = 'RepositoryPoliciesActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class GetRepositoryPolicyById {
        static readonly type = 'RepositoryPoliciesActions.GetRepositoryPolicyById';

        constructor(public id: string) {
        }
    }

    export class GetRepositoryPolicyByIdHistoricVersion {
        static readonly type = 'RepositoryPoliciesActions.GetRepositoryPolicyByIdHistoricVersion';

        constructor(public id: string, public version: string) {
        }
    }

    export class DownloadPolicyPrintout {
        static readonly type = 'RepositoryPoliciesActions.DownloadPolicyPrintout';

        constructor(public policyId: string) {
        }
    }

    export class GetInstallmentsAndClaims {
        static readonly type = 'RepositoryPoliciesActions.GetInstallmentsAndClaims';
    }

    export class OpenTerminationAside {
        static readonly type = 'RepositoryPoliciesActions.OpenTerminationAside';
    }

    export class OpenDataChangeAside {
        static readonly type = 'RepositoryPoliciesActions.OpenDataChangeAside';
    }

    export class OpenDocumentsAside {
        static readonly type = 'RepositoryPoliciesActions.OpenDocumentsAside';
    }

    export class ClearListItems {
        static readonly type = 'RepositoryPoliciesActions.ClearListItems';
    }

    export class ClearList {
        static readonly type = 'RepositoryPoliciesActions.ClearList';
    }

    export class Clear {
        static readonly type = 'RepositoryPoliciesActions.Clear';
    }

    export class CloseAside {
        static readonly type = 'RepositoryPoliciesActions.CloseAside';
    }

    export class FormFailure {
        static readonly type = 'RepositoryPoliciesActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class DownloadFile {
        static readonly type = 'RepositoryPoliciesActions.DownloadFile';

        constructor(public hash: string) {
        }
    }
}
